import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

const getHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,

  "x-user-id": sessionStorage.getItem("user_id"),

  "x-college-id": sessionStorage.getItem("college_id"),
});

const rbacApi = axios.create({
  baseURL: `${API_BASE}/api/rbacall`,
});

export const getRoles = async () => {
  const response = await rbacApi.get("/roles", {
    headers: getHeaders(),
  });

  return response.data.data;
};

export const createRole = async (data) => {
  const response = await rbacApi.post("/roles", data, {
    headers: getHeaders(),
  });

  return response.data;
};

export const updateRole = async (roleId, data) => {
  const response = await rbacApi.put(`/roles/${roleId}`, data, {
    headers: getHeaders(),
  });

  return response.data;
};

export const deleteRole = async (roleId) => {
  const response = await rbacApi.delete(`/roles/${roleId}`, {
    headers: getHeaders(),
  });

  return response.data;
};

export const getModules = async () => {
  const response = await rbacApi.get("/modules", {
    headers: getHeaders(),
  });

  return response.data.data;
};

export const getRolePermissions = async (roleId) => {
  const response = await rbacApi.get(`/roles/${roleId}/permissions`, {
    headers: getHeaders(),
  });

  return response.data.data;
};

export const saveRolePermissions = async (roleId, data) => {
  const response = await rbacApi.put(`/roles/${roleId}/permissions`, data, {
    headers: getHeaders(),
  });

  return response.data;
};

export const getUserColleges = async (userId) => {
  const response = await rbacApi.get(`/users/${userId}/colleges`, {
    headers: getHeaders(),
  });

  return response.data.data;
};

export const assignUserCollege = async (userId, data) => {
  const response = await rbacApi.post(`/users/${userId}/colleges`, data, {
    headers: getHeaders(),
  });

  return response.data;
};

export const removeUserCollege = async (userId, collegeId) => {
  const response = await rbacApi.delete(`/users/${userId}/colleges/${collegeId}`, {
    headers: getHeaders(),
  });

  return response.data;
};

export const getUserCollegeRoles = async (userId, collegeId) => {
  const response = await rbacApi.get(`/users/${userId}/colleges/${collegeId}/roles`, {
    headers: getHeaders(),
  });

  return response.data.data;
};

export const assignUserCollegeRole = async (userId, collegeId, data) => {
  const response = await rbacApi.post(`/users/${userId}/colleges/${collegeId}/roles`, data, {
    headers: getHeaders(),
  });

  return response.data;
};

export const removeUserCollegeRole = async (userId, collegeId, roleId) => {
  const response = await rbacApi.delete(`/users/${userId}/colleges/${collegeId}/roles/${roleId}`, {
    headers: getHeaders(),
  });

  return response.data;
};

export const getMyPermissions = async () => {
  const response = await rbacApi.get("/my-permissions", {
    headers: getHeaders(),
  });

  return response.data.data;
};
